import { z } from "zod";

const ExportTreatmentsSchema = z.object({
  search: z.string().optional(),
  format: z.enum(["csv", "json"]),
  query: z.any().optional(),
  sort: z.array(z.object({ property: z.string(), asc: z.boolean() })).optional(),
});

export default ExportTreatmentsSchema;